export function fillSlider(from: number, to: number, controlSlider: Ref) {
  const sliderColor = '#8b8a93';
  const rangeColor = '#068484';

  const rangeDistance = controlSlider.value?.max - controlSlider.value?.min;
  const fromPosition = from - controlSlider.value?.min;
  const toPosition = to - controlSlider.value?.min;

  controlSlider.value.style.background = `linear-gradient(
      to right,
      ${sliderColor} 0%,
      ${sliderColor} ${(fromPosition / rangeDistance) * 100}%,
      ${rangeColor} ${(fromPosition / rangeDistance) * 100}%,
      ${rangeColor} ${(toPosition / rangeDistance) * 100}%,
      ${sliderColor} ${(toPosition / rangeDistance) * 100}%,
      ${sliderColor} 100%)`;
}

export function getThumbPosition(value: number, slider: HTMLInputElement) {
  const { max, min } = slider;
  const range = Number(max) - Number(min);
  return ((value - Number(min)) / range) * 100;
}
